module.exports = __webpack_public_path__ + "img/subt.692a8e5c.svg";